import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/175638/234820833-c803cb11-2bc3-4597-88f3-2cf630a46702.png",
        "alt": "An image showing two different avatars, a circular and a square one."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use avatars to display a thumbnail that represents individuals in various contexts, such as testimonials, speaker sessions, blog post authors, and beyond.`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`Avatar offers various sizes to fit different layout and visual scale needs. Sizes range from 32 to 80 pixels. Ensure the avatar is proportionate to its accompanying text.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/175638/234826575-1d1d5019-f714-41b1-b8bc-c0d312a46cfe.png",
        "alt": "An image showing the size scale of the avatar component: 32, 40, 48, 64, and 80 pixels"
      }}></img></p>
    <h3>{`Shape`}</h3>
    <p>{`Avatars appear as two different shapes: circle and square. The choice depends on the desired visual impression and the overall design aesthetic of your project.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/175638/234827120-da548115-450b-4ec8-a6e6-5dcbe98e77c5.png",
        "alt": "An image showing the two different shapes of the avatar component: circle and square"
      }}></img></p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Image"
        }}>{`Image`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Testimonial"
        }}>{`Testimonial`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      